const ANCHOR_SELECTORS = [
  ".main-product",
  ".shopify-section--pdp-lifestyle-hero",
];

class StickyAtc extends HTMLElement {
  constructor() {
    super();

    const body = this.closest("body");
    if (!body) return;

    this.anchors = ANCHOR_SELECTORS.map((selector) =>
      body.querySelector(selector),
    ).filter(Boolean);
    this.onScreen = new Set();
    this.button = this.querySelector("button add-to-cart");
  }

  connectedCallback() {
    this.scrollObserver();
  }

  scrollObserver() {
    if (!this.anchors?.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // A section wrapper with no height rendered nothing, so it can't hide anything
        const onScreen =
          entry.isIntersecting && entry.boundingClientRect.height > 0;

        onScreen
          ? this.onScreen.add(entry.target)
          : this.onScreen.delete(entry.target);
      });

      this.onScreen.size ? this.hideButton() : this.showButton();
    });

    this.anchors.forEach((anchor) => observer.observe(anchor));
  }

  setHeight() {
    const stickyHeader = document.querySelector("sticky-header");
    const stickyHeaderHeight = stickyHeader.offsetHeight;

    this.style.setProperty("--sticky-header-height", `${stickyHeaderHeight}px`);
  }

  hideButton() {
    clearTimeout(this.showTimeout);
    this.classList.remove("is-visible");
  }

  showButton() {
    this.showTimeout = setTimeout(() => {
      this.setHeight();
      window.requestAnimationFrame(() => {
        this.classList.add("is-visible");
      });
    }, 300);
  }
}

if (!customElements.get("sticky-atc")) {
  customElements.define("sticky-atc", StickyAtc);
}
